export default __webpack_public_path__ + "static/media/download-outline-16px.437fd832.svg";